import { defineComponent, computed, resolveComponent, openBlock, createBlock, normalizeProps, guardReactiveProps, withCtx, createElementBlock, Fragment, renderList, renderSlot, createCommentVNode } from "vue";
import { c as instance } from "../malarkeyTwilioAdapter-1c296255.mjs";
import MalarkeyContactSearchItem from "./constituants/MalarkeyContactSearchItem.es.js";
import { V as VList } from "../_VList-61c79735.mjs";
import { u as useDefaults, _ as _export_sfc } from "../_plugin-vue_export-helper-3194dc60.mjs";
import "../index-13be80af.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "../_debug-8b5c3032.mjs";
import "joi";
import "../helpers-674591c1.mjs";
import "../MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
import "../_VListItem-508e4b13.mjs";
import "../_density-8094aebe.mjs";
import "../MalarkeyContactAvatar-1b079ba3.mjs";
import "../_proxiedModel-031e293c.mjs";
import "../_common-fcf3ef61.mjs";
import "../i18n-35335a5c.mjs";
import "../index-38c53cf2.mjs";
import "../_i18n-e414d464.mjs";
import "../index-64135f7d.mjs";
import "../index-703c58ee.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import "../otpauth.esm-675c01d0.mjs";
import "../sudo-bad5b55e.mjs";
import "../index-fd2245c5.mjs";
import "../index-dbde2d54.mjs";
const _sfc_main = defineComponent({
  name: "MalarkeyContactRoster",
  components: {
    MalarkeyContactSearchItem
  },
  props: {
    ...VList.props,
    /**
     * Defines the function used to sort the displayed results.
     */
    sortFn: {
      type: Function,
      default: void 0
    },
    /**
     * Defines the maximum number of items to display. A value of -1 will display all items.
     */
    limit: {
      type: Number,
      default: -1
    },
    /**
     * Defines the function to call when a roster item is clicked
     */
    onClick: {
      type: Function,
      default: () => () => {
      }
    },
    /**
     * Defines if the click action should be disabled
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [...Object.keys({ ...VList.emits })],
  setup(props) {
    const defaultsFromVList = useDefaults(props, "VList");
    const defaultsFromMalarkeyContactRoster = useDefaults(
      defaultsFromVList,
      "MalarkeyContactRoster"
    );
    const roster = computed(() => {
      const ret = [];
      if (instance.value && Array.isArray(instance.value.roster.value)) {
        const toAdd = [...instance.value.roster.value].sort((a, b) => {
          if (props.sortFn) {
            return props.sortFn(a, b);
          } else {
            return 0;
          }
        });
        if (props.limit > -1) {
          ret.push(...toAdd.slice(0, props.limit));
        } else {
          ret.push(...toAdd);
        }
      }
      return ret;
    });
    const bindings = computed(() => ({
      ...defaultsFromMalarkeyContactRoster,
      sortFn: void 0,
      limit: void 0
    }));
    return {
      roster,
      bindings
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MalarkeyContactSearchItem = resolveComponent("MalarkeyContactSearchItem");
  const _component_v_list = resolveComponent("v-list");
  return openBlock(), createBlock(_component_v_list, normalizeProps(guardReactiveProps(_ctx.bindings)), {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.roster, (c, i) => {
        return openBlock(), createBlock(_component_MalarkeyContactSearchItem, {
          key: i,
          user: c,
          disabled: _ctx.disabled,
          onClick: ($e) => _ctx.onClick($e, c)
        }, null, 8, ["user", "disabled", "onClick"]);
      }), 128)),
      _ctx.roster.length === 0 ? renderSlot(_ctx.$slots, "empty", { key: 0 }) : createCommentVNode("", true)
    ]),
    _: 3
  }, 16);
}
const MalarkeyContactRoster = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyContactRoster.vue"]]);
export {
  MalarkeyContactRoster as default
};
//# sourceMappingURL=MalarkeyContactRoster.es.js.map
